export const TabValues = {
  GENERAL_INGO: 'generalInfo',
  ADMIN: 'admin',
};
